export default "__VITE_ASSET__b17993fc__"